var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg503(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 394,
    height: 328,
    viewBox: "0 0 394 328",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.037,
    d: "M192.048 227.89C192.048 244.409 217.109 259.107 248.012 260.732C278.914 262.343 303.975 250.265 303.975 233.746C303.975 217.227 278.914 202.528 248.012 200.904C217.109 199.28 192.048 211.371 192.048 227.89Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.074,
    d: "M193.019 227.942C193.019 244.172 217.634 258.622 248.013 260.207C278.379 261.792 303.007 249.923 303.007 233.692C303.007 217.462 278.392 203.012 248.013 201.427C217.634 199.842 193.019 211.711 193.019 227.942Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.111,
    d: "M194 228C194 243.943 218.183 258.143 248.011 259.702C277.84 261.261 302.023 249.602 302.023 233.646C302.023 217.704 277.84 203.503 248.011 201.944C218.183 200.385 194 212.058 194 228Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.148,
    d: "M194.97 228.05C194.97 243.704 218.721 257.643 248.012 259.175C277.304 260.708 301.054 249.246 301.054 233.591C301.054 217.937 277.304 203.998 248.012 202.466C218.721 200.933 194.97 212.395 194.97 228.05Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.185,
    d: "M195.939 228.1C195.939 243.479 219.257 257.155 248.011 258.662C276.766 260.168 300.084 248.916 300.084 233.549C300.084 218.17 276.766 204.493 248.011 202.987C219.257 201.48 195.939 212.72 195.939 228.1Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.222,
    d: "M196.908 228.149C196.908 243.24 219.781 256.655 248.011 258.135C276.229 259.615 299.114 248.572 299.114 233.494C299.114 218.403 276.242 204.988 248.011 203.508C219.781 202.028 196.908 213.058 196.908 228.149Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.259,
    d: "M197.878 228.206C197.878 243.009 220.319 256.174 248.012 257.615C275.692 259.056 298.146 248.236 298.146 233.433C298.146 218.63 275.706 205.464 248.012 204.023C220.332 202.582 197.878 213.403 197.878 228.206Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.296,
    d: "M198.86 228.248C198.86 242.762 220.868 255.679 248.012 257.094C275.155 258.509 297.163 247.898 297.176 233.383C297.176 218.868 275.168 205.951 248.025 204.537C220.881 203.122 198.86 213.746 198.86 228.248Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.333,
    d: "M199.83 228.297C199.83 242.524 221.406 255.179 248.012 256.567C274.618 257.956 296.194 247.554 296.194 233.328C296.194 219.101 274.618 206.447 248.012 205.058C221.406 203.669 199.83 214.071 199.83 228.297Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M200.8 228.355C200.8 242.293 221.944 254.699 248.013 256.061C274.095 257.424 295.225 247.232 295.225 233.293C295.225 219.355 274.082 206.949 248.013 205.587C221.931 204.225 200.8 214.416 200.8 228.355Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.407,
    d: "M201.768 228.402C201.768 242.052 222.466 254.196 248.011 255.532C273.556 256.868 294.254 246.886 294.254 233.223C294.254 219.572 273.556 207.429 248.011 206.092C222.466 204.756 201.768 214.752 201.768 228.402Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.444,
    d: "M202.738 228.453C202.738 241.815 223.004 253.71 248.012 255.02C273.02 256.33 293.285 246.544 293.285 233.182C293.285 219.82 273.02 207.926 248.012 206.616C223.004 205.319 202.738 215.091 202.738 228.453Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.481,
    d: "M203.708 228.503C203.708 241.577 223.541 253.223 248.012 254.493C272.483 255.777 292.316 246.201 292.316 233.127C292.316 220.053 272.483 208.407 248.012 207.137C223.541 205.866 203.708 215.429 203.708 228.503Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.518,
    d: "M204.69 228.555C204.69 241.34 224.091 252.724 248.012 253.982C271.945 255.226 291.333 245.873 291.333 233.087C291.333 220.302 271.932 208.918 248.012 207.66C224.078 206.403 204.69 215.756 204.69 228.555Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.556,
    d: "M205.659 228.61C205.659 241.121 224.628 252.242 248.011 253.461C271.408 254.679 290.364 245.535 290.364 233.038C290.364 220.527 271.395 209.405 248.011 208.187C224.628 206.969 205.659 216.1 205.659 228.61Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.593,
    d: "M206.629 228.647C206.629 240.869 225.153 251.742 248.012 252.934C270.872 254.127 289.395 245.192 289.395 232.97C289.395 220.748 270.872 209.875 248.012 208.683C225.153 207.504 206.629 216.438 206.629 228.647Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M207.598 228.703C207.598 240.637 225.689 251.248 248.012 252.414C270.334 253.58 288.425 244.855 288.425 232.921C288.425 220.987 270.334 210.376 248.012 209.21C225.689 208.044 207.598 216.782 207.598 228.703Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.667,
    d: "M208.568 228.752C208.568 240.398 226.227 250.76 248.012 251.9C269.798 253.04 287.457 244.525 287.457 232.879C287.457 221.233 269.798 210.871 248.012 209.731C226.227 208.591 208.568 217.106 208.568 228.752Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.704,
    d: "M209.537 228.806C209.537 240.164 226.763 250.264 248.011 251.377C269.26 252.491 286.486 244.185 286.486 232.828C286.486 221.47 269.26 211.37 248.011 210.256C226.763 209.143 209.537 217.448 209.537 228.806Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.741,
    d: "M210.52 228.859C210.52 239.928 227.314 249.779 248.012 250.867C268.71 251.954 285.504 243.858 285.504 232.776C285.504 221.693 268.71 211.855 248.012 210.768C227.301 209.693 210.52 217.789 210.52 228.859Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.778,
    d: "M211.489 228.908C211.489 239.69 227.838 249.292 248.012 250.34C268.186 251.388 284.535 243.502 284.535 232.72C284.535 221.939 268.186 212.337 248.012 211.289C227.838 210.241 211.489 218.127 211.489 228.908Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.815,
    d: "M212.458 228.964C212.458 239.457 228.374 248.797 248.011 249.832C267.648 250.867 283.564 243.178 283.564 232.684C283.564 222.191 267.648 212.851 248.011 211.816C228.374 210.781 212.458 218.458 212.458 228.964Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.852,
    d: "M213.428 229.014C213.428 239.219 228.912 248.31 248.012 249.306C267.112 250.301 282.596 242.834 282.596 232.629C282.596 222.424 267.112 213.333 248.012 212.337C228.912 211.329 213.428 218.796 213.428 229.014Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.889,
    d: "M214.397 229.057C214.397 238.974 229.449 247.803 248.012 248.773C266.575 249.742 281.627 242.485 281.627 232.568C281.627 222.651 266.575 213.822 248.012 212.852C229.449 211.883 214.397 219.14 214.397 229.057Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.926,
    d: "M215.379 229.114C215.379 238.755 229.986 247.323 248.011 248.266C266.037 249.209 280.644 242.161 280.644 232.52C280.644 222.878 266.037 214.311 248.011 213.368C229.986 212.437 215.379 219.485 215.379 229.114Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.963,
    d: "M216.349 229.163C216.349 238.517 230.523 246.835 248.011 247.739C265.5 248.656 279.674 241.818 279.674 232.465C279.674 223.111 265.5 214.793 248.011 213.889C230.523 212.985 216.349 219.823 216.349 229.163Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.318 229.215C217.318 238.28 231.06 246.337 248.012 247.228C264.963 248.119 278.705 241.49 278.705 232.425C278.705 223.36 264.963 215.303 248.012 214.412C231.06 213.521 217.318 220.15 217.318 229.215Z",
    fill: "#030511"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.037,
    d: "M94.2041 289.054C94.2041 305.573 119.264 320.271 150.167 321.896C181.07 323.507 206.13 311.429 206.13 294.91C206.13 278.391 181.07 263.693 150.167 262.068C119.251 260.444 94.2041 272.535 94.2041 289.054Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.074,
    d: "M95.1738 289.106C95.1738 305.336 119.789 319.786 150.168 321.371C180.547 322.956 205.161 311.087 205.161 294.857C205.161 278.626 180.547 264.176 150.168 262.591C119.789 261.006 95.1738 272.875 95.1738 289.106Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.111,
    d: "M96.1431 289.164C96.1431 305.107 120.326 319.308 150.154 320.866C179.983 322.425 204.166 310.766 204.166 294.811C204.166 278.868 179.983 264.667 150.154 263.109C120.326 261.55 96.1431 273.209 96.1431 289.164Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.148,
    d: "M97.1133 289.214C97.1133 304.869 120.864 318.807 150.155 320.34C179.447 321.872 203.197 310.41 203.197 294.755C203.197 279.101 179.447 265.162 150.155 263.63C120.864 262.097 97.1133 273.546 97.1133 289.214Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.185,
    d: "M98.082 289.25C98.082 304.629 121.4 318.306 150.155 319.812C178.909 321.319 202.227 310.066 202.227 294.699C202.227 279.32 178.909 265.644 150.155 264.137C121.4 262.644 98.082 273.883 98.082 289.25Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.222,
    d: "M99.0513 289.301C99.0513 304.393 121.924 317.807 150.154 319.287C178.385 320.768 201.257 309.724 201.257 294.646C201.257 279.555 178.385 266.141 150.154 264.66C121.937 263.18 99.0513 274.223 99.0513 289.301Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.259,
    d: "M100.034 289.354C100.034 304.157 122.474 317.323 150.168 318.764C177.848 320.205 200.302 309.384 200.302 294.581C200.302 279.778 177.861 266.613 150.168 265.172C122.474 263.731 100.034 274.564 100.034 289.354Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.296,
    d: "M101.003 289.412C101.003 303.927 123.011 316.843 150.155 318.258C177.298 319.673 199.306 309.062 199.319 294.547C199.319 280.032 177.311 267.116 150.168 265.701C123.025 264.286 101.003 274.897 101.003 289.412Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.333,
    d: "M101.973 289.461C101.973 303.688 123.549 316.343 150.155 317.731C176.761 319.12 198.337 308.718 198.337 294.492C198.337 280.265 176.761 267.611 150.155 266.222C123.549 264.833 101.973 275.235 101.973 289.461Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M102.943 289.519C102.943 303.457 124.087 315.863 150.156 317.225C176.238 318.588 197.368 308.396 197.368 294.458C197.368 280.519 176.225 268.113 150.156 266.751C124.087 265.389 102.943 275.58 102.943 289.519Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.407,
    d: "M103.911 289.566C103.911 303.216 124.609 315.36 150.154 316.696C175.699 318.032 196.397 308.05 196.397 294.387C196.397 280.736 175.699 268.593 150.154 267.257C124.622 265.92 103.911 275.916 103.911 289.566Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.444,
    d: "M104.895 289.616C104.895 302.978 125.161 314.872 150.169 316.182C175.177 317.492 195.442 307.707 195.442 294.345C195.442 280.983 175.177 269.088 150.169 267.778C125.161 266.468 104.895 276.24 104.895 289.616Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.481,
    d: "M105.863 289.659C105.863 302.733 125.697 314.379 150.167 315.649C174.638 316.92 194.472 307.357 194.472 294.283C194.472 281.21 174.638 269.564 150.167 268.293C125.697 267.022 105.863 276.585 105.863 289.659Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.518,
    d: "M106.833 289.713C106.833 302.498 126.234 313.882 150.155 315.14C174.088 316.384 193.476 307.031 193.476 294.245C193.476 281.46 174.075 270.076 150.155 268.818C126.234 267.574 106.833 276.927 106.833 289.713Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.556,
    d: "M107.803 289.762C107.803 302.273 126.772 313.395 150.156 314.613C173.539 315.831 192.508 306.687 192.508 294.19C192.508 281.68 173.539 270.558 150.156 269.339C126.772 268.121 107.803 277.265 107.803 289.762Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.593,
    d: "M108.772 289.813C108.772 302.036 127.296 312.909 150.155 314.101C173.015 315.293 191.538 306.359 191.538 294.136C191.538 281.914 173.015 271.041 150.155 269.849C127.309 268.657 108.772 277.591 108.772 289.813Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M109.741 289.867C109.741 301.801 127.832 312.412 150.155 313.578C172.477 314.744 190.568 306.019 190.568 294.085C190.568 282.151 172.477 271.54 150.155 270.374C127.845 269.208 109.741 277.933 109.741 289.867Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.667,
    d: "M110.724 289.916C110.724 301.562 128.383 311.924 150.168 313.064C171.954 314.204 189.612 305.689 189.612 294.043C189.612 282.397 171.954 272.035 150.168 270.895C128.383 269.756 110.724 278.271 110.724 289.916Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.704,
    d: "M111.692 289.97C111.692 301.328 128.919 311.428 150.167 312.541C171.415 313.655 188.642 305.349 188.642 293.992C188.642 282.634 171.415 272.534 150.167 271.42C128.919 270.307 111.692 278.612 111.692 289.97Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.741,
    d: "M112.663 290.023C112.663 301.092 129.457 310.943 150.155 312.031C170.866 313.118 187.647 305.022 187.647 293.94C187.647 282.87 170.853 273.019 150.155 271.932C129.444 270.857 112.663 278.953 112.663 290.023Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.778,
    d: "M113.632 290.061C113.632 300.842 129.981 310.444 150.155 311.492C170.329 312.54 186.678 304.654 186.678 293.873C186.678 283.091 170.329 273.489 150.155 272.441C129.981 271.393 113.632 279.279 113.632 290.061Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.815,
    d: "M114.601 290.11C114.601 300.603 130.517 309.944 150.154 310.979C169.791 312 185.707 304.324 185.707 293.831C185.707 283.338 169.791 273.997 150.154 272.962C130.517 271.941 114.601 279.617 114.601 290.11Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.852,
    d: "M115.571 290.168C115.571 300.373 131.055 309.464 150.155 310.46C169.255 311.455 184.739 303.988 184.739 293.783C184.739 283.578 169.255 274.487 150.155 273.491C131.055 272.496 115.571 279.963 115.571 290.168Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.889,
    d: "M116.552 290.221C116.552 300.138 131.604 308.967 150.167 309.937C168.73 310.906 183.781 303.649 183.781 293.732C183.781 283.815 168.73 274.986 150.167 274.017C131.591 273.047 116.552 280.305 116.552 290.221Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.926,
    d: "M117.522 290.272C117.522 299.914 132.129 308.481 150.155 309.424C168.18 310.368 182.787 303.32 182.787 293.678C182.787 284.037 168.18 275.469 150.155 274.526C132.129 273.583 117.522 280.631 117.522 290.272Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.963,
    d: "M118.492 290.322C118.492 299.675 132.666 307.994 150.154 308.898C167.643 309.802 181.817 302.976 181.817 293.623C181.817 284.27 167.643 275.951 150.154 275.047C132.666 274.13 118.492 280.968 118.492 290.322Z",
    fill: "#030511"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.461 290.379C119.461 299.445 133.203 307.501 150.155 308.392C167.106 309.283 180.848 302.654 180.848 293.589C180.848 284.524 167.106 276.467 150.155 275.576C133.203 274.686 119.461 281.314 119.461 290.379Z",
    fill: "#030511"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M326.048 188.113V200.938L257.089 240.684V227.859L326.048 188.113Z",
    fill: "url(#paint0_linear_1133_95138)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M257.089 227.865V240.69L170.105 190.399V177.574L257.089 227.865Z",
    fill: "url(#paint1_linear_1133_95138)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M326.048 188.119L257.089 227.864L170.105 177.574L239.064 137.828L326.048 188.119Z",
    fill: "url(#paint2_linear_1133_95138)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M257.089 227.387L170.498 177.332L170.105 177.568L257.089 227.859L326.048 188.113L325.655 187.878L257.089 227.387Z",
    fill: "url(#paint3_linear_1133_95138)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M307.905 61.3594L307.696 187.866L259.684 215.533L259.907 89.0397L307.905 61.3594Z",
    fill: "url(#paint4_linear_1133_95138)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M259.907 89.0396L259.685 215.533L190.503 175.591L190.713 49.0977L259.907 89.0396Z",
    fill: "url(#paint5_linear_1133_95138)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M307.905 61.356L259.907 89.0363L190.712 49.0944L238.724 21.4141L307.905 61.356Z",
    fill: "url(#paint6_linear_1133_95138)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M259.907 88.7144L191.001 48.9297L190.712 49.1L259.907 89.0419L307.905 61.3616L307.63 61.2044L259.907 88.7144Z",
    fill: "url(#paint7_linear_1133_95138)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M300.216 54.6992V60.0309L258.505 84.0694V78.7377L300.216 54.6992Z",
    fill: "url(#paint8_linear_1133_95138)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M258.505 78.737V84.0688L198.389 49.3669V44.0352L258.505 78.737Z",
    fill: "url(#paint9_linear_1133_95138)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M300.215 54.7019L258.505 78.7404L198.389 44.0385L240.1 20L300.215 54.7019Z",
    fill: "url(#paint10_linear_1133_95138)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M258.505 78.4654L198.625 43.8945L198.389 44.0386L258.505 78.7405L300.215 54.702L299.967 54.5579L258.505 78.4654Z",
    fill: "url(#paint11_linear_1133_95138)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M311.558 85.2773L311.427 150.843L267.215 176.532L267.346 110.98L311.558 85.2773Z",
    fill: "url(#paint12_linear_1133_95138)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M267.346 110.979L267.215 176.531L262.748 174.042L262.892 108.477L267.346 110.979Z",
    fill: "url(#paint13_linear_1133_95138)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M311.559 85.2781L267.347 110.98L262.893 108.478L307.105 82.7891L311.559 85.2781Z",
    fill: "url(#paint14_linear_1133_95138)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M267.347 110.773L263.063 108.376L262.893 108.481L267.347 110.983L311.559 85.2806L311.389 85.1758L267.347 110.773Z",
    fill: "url(#paint15_linear_1133_95138)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M304.969 98.8633L304.864 144.91L273.804 162.962L273.909 116.902L304.969 98.8633Z",
    fill: "url(#paint16_linear_1133_95138)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M301.878 100.645V142.984L304.865 144.91V98.8633L301.878 100.645Z",
    fill: "#3C4682"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M301.877 142.984L273.804 158.927V162.962L304.864 144.91L301.877 142.984Z",
    fill: "#5F6CBF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M289.617 116.101L296.482 112.21C296.704 112.092 296.875 111.804 296.888 111.568C296.888 111.345 296.717 111.254 296.495 111.385L289.63 115.275C289.408 115.393 289.237 115.681 289.224 115.917C289.224 116.14 289.408 116.232 289.617 116.101Z",
    fill: "url(#paint17_linear_1133_95138)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M289.891 117.937L294.135 115.526C294.358 115.408 294.528 115.12 294.541 114.884C294.541 114.662 294.371 114.57 294.148 114.701L289.904 117.111C289.681 117.229 289.511 117.517 289.498 117.753C289.498 117.976 289.668 118.055 289.891 117.937Z",
    fill: "url(#paint18_linear_1133_95138)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M283.943 121.304L288.188 118.893C288.41 118.776 288.581 118.487 288.594 118.252C288.594 118.029 288.423 117.937 288.201 118.068L283.956 120.479C283.734 120.596 283.563 120.885 283.55 121.12C283.55 121.343 283.721 121.422 283.943 121.304Z",
    fill: "url(#paint19_linear_1133_95138)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M286.931 121.594L292.905 118.214C293.127 118.096 293.298 117.808 293.311 117.572C293.311 117.349 293.14 117.257 292.918 117.388L286.944 120.768C286.721 120.886 286.551 121.174 286.538 121.41C286.538 121.633 286.708 121.711 286.931 121.594Z",
    fill: "url(#paint20_linear_1133_95138)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M278.612 126.293L284.585 122.913C284.808 122.795 284.978 122.507 284.991 122.271C284.991 122.048 284.821 121.957 284.598 122.088L278.625 125.468C278.402 125.585 278.232 125.874 278.219 126.109C278.219 126.332 278.402 126.424 278.612 126.293Z",
    fill: "url(#paint21_linear_1133_95138)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M288.712 122.566L293.756 119.71C293.979 119.592 294.149 119.304 294.162 119.068C294.162 118.845 293.992 118.754 293.769 118.885L288.725 121.74C288.503 121.858 288.332 122.146 288.319 122.382C288.319 122.605 288.49 122.684 288.712 122.566Z",
    fill: "url(#paint22_linear_1133_95138)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M282.437 126.105L287.48 123.249C287.703 123.131 287.873 122.843 287.887 122.607C287.887 122.384 287.716 122.293 287.494 122.424L282.45 125.279C282.227 125.397 282.057 125.686 282.044 125.921C282.057 126.144 282.227 126.223 282.437 126.105Z",
    fill: "url(#paint23_linear_1133_95138)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M291.202 123.139L296.35 120.218C296.573 120.1 296.743 119.812 296.756 119.576C296.756 119.353 296.586 119.261 296.363 119.392L291.215 122.314C290.992 122.432 290.822 122.72 290.809 122.956C290.809 123.178 290.979 123.257 291.202 123.139Z",
    fill: "url(#paint24_linear_1133_95138)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M284.468 126.951L289.617 124.03C289.839 123.912 290.01 123.624 290.023 123.388C290.023 123.166 289.852 123.074 289.63 123.205L284.481 126.126C284.259 126.244 284.088 126.532 284.075 126.768C284.075 126.991 284.245 127.069 284.468 126.951Z",
    fill: "url(#paint25_linear_1133_95138)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M280.302 129.309L282.87 127.854C283.092 127.737 283.263 127.448 283.276 127.213C283.276 126.99 283.106 126.898 282.883 127.029L280.315 128.483C280.093 128.601 279.922 128.889 279.909 129.125C279.909 129.348 280.079 129.426 280.302 129.309Z",
    fill: "url(#paint26_linear_1133_95138)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M288.843 126.456L294.214 123.417C294.436 123.299 294.607 123.011 294.62 122.775C294.62 122.552 294.449 122.461 294.227 122.592L288.856 125.631C288.633 125.749 288.463 126.037 288.45 126.273C288.45 126.495 288.62 126.574 288.843 126.456Z",
    fill: "url(#paint27_linear_1133_95138)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M281.888 130.378L287.259 127.339C287.481 127.221 287.652 126.933 287.665 126.697C287.665 126.474 287.494 126.382 287.272 126.513L281.901 129.553C281.678 129.671 281.508 129.959 281.495 130.195C281.495 130.417 281.678 130.509 281.888 130.378Z",
    fill: "url(#paint28_linear_1133_95138)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M289.97 127.788L294.228 125.378C294.45 125.26 294.621 124.972 294.634 124.736C294.634 124.513 294.463 124.422 294.241 124.553L289.983 126.963C289.761 127.081 289.59 127.369 289.577 127.605C289.577 127.828 289.747 127.919 289.97 127.788Z",
    fill: "url(#paint29_linear_1133_95138)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M291.017 131.003L295.275 128.593C295.497 128.475 295.668 128.187 295.681 127.951C295.681 127.728 295.51 127.636 295.288 127.767L291.03 130.178C290.807 130.296 290.637 130.584 290.624 130.82C290.624 131.042 290.794 131.134 291.017 131.003Z",
    fill: "url(#paint30_linear_1133_95138)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M285.097 134.39L289.355 131.979C289.577 131.862 289.748 131.573 289.761 131.338C289.761 131.115 289.59 131.023 289.368 131.154L285.11 133.565C284.888 133.682 284.717 133.971 284.704 134.206C284.717 134.429 284.888 134.521 285.097 134.39Z",
    fill: "url(#paint31_linear_1133_95138)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M292.092 132.839L296.35 130.429C296.572 130.311 296.743 130.023 296.756 129.787C296.756 129.564 296.586 129.472 296.363 129.603L292.105 132.014C291.883 132.132 291.712 132.42 291.699 132.656C291.699 132.865 291.87 132.957 292.092 132.839Z",
    fill: "url(#paint32_linear_1133_95138)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M283.498 137.823L287.755 135.413C287.978 135.295 288.148 135.007 288.162 134.771C288.162 134.548 287.991 134.457 287.769 134.588L283.511 136.998C283.288 137.116 283.118 137.404 283.105 137.64C283.105 137.863 283.275 137.954 283.498 137.823Z",
    fill: "url(#paint33_linear_1133_95138)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M284.259 131.023L288.517 128.612C288.739 128.494 288.91 128.206 288.923 127.97C288.923 127.748 288.752 127.656 288.53 127.787L284.272 130.197C284.05 130.315 283.879 130.603 283.866 130.839C283.866 131.062 284.05 131.141 284.259 131.023Z",
    fill: "url(#paint34_linear_1133_95138)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M289.38 130.108L296.245 126.218C296.467 126.1 296.638 125.812 296.651 125.576C296.651 125.353 296.481 125.261 296.258 125.392L289.393 129.283C289.171 129.401 289 129.689 288.987 129.925C288.987 130.148 289.158 130.226 289.38 130.108Z",
    fill: "url(#paint35_linear_1133_95138)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M288.843 136.812L294.214 133.772C294.436 133.654 294.607 133.366 294.62 133.13C294.62 132.908 294.449 132.816 294.227 132.947L288.856 135.986C288.633 136.104 288.463 136.392 288.45 136.628C288.45 136.851 288.62 136.943 288.843 136.812Z",
    fill: "url(#paint36_linear_1133_95138)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M281.888 140.757L287.259 137.718C287.481 137.6 287.652 137.312 287.665 137.076C287.665 136.853 287.494 136.761 287.272 136.892L281.901 139.932C281.678 140.049 281.508 140.338 281.495 140.573C281.495 140.783 281.678 140.875 281.888 140.757Z",
    fill: "url(#paint37_linear_1133_95138)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M289.97 138.159L294.228 135.749C294.45 135.631 294.621 135.343 294.634 135.107C294.634 134.884 294.463 134.793 294.241 134.924L289.983 137.334C289.761 137.452 289.59 137.74 289.577 137.976C289.577 138.186 289.747 138.277 289.97 138.159Z",
    fill: "url(#paint38_linear_1133_95138)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M291.017 141.374L295.275 138.964C295.497 138.846 295.668 138.558 295.681 138.322C295.681 138.099 295.51 138.007 295.288 138.138L291.03 140.549C290.807 140.667 290.637 140.955 290.624 141.191C290.624 141.413 290.794 141.492 291.017 141.374Z",
    fill: "url(#paint39_linear_1133_95138)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M285.097 144.765L289.355 142.354C289.577 142.237 289.748 141.948 289.761 141.713C289.761 141.49 289.59 141.398 289.368 141.529L285.11 143.94C284.888 144.057 284.717 144.346 284.704 144.581C284.717 144.804 284.888 144.883 285.097 144.765Z",
    fill: "url(#paint40_linear_1133_95138)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M292.092 143.206L296.35 140.796C296.572 140.678 296.743 140.39 296.756 140.154C296.756 139.931 296.586 139.84 296.363 139.971L292.105 142.381C291.883 142.499 291.712 142.787 291.699 143.023C291.699 143.246 291.87 143.324 292.092 143.206Z",
    fill: "url(#paint41_linear_1133_95138)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M283.498 148.187L287.755 145.776C287.978 145.658 288.148 145.37 288.162 145.134C288.162 144.912 287.991 144.82 287.769 144.951L283.511 147.361C283.288 147.479 283.118 147.767 283.105 148.003C283.105 148.226 283.275 148.318 283.498 148.187Z",
    fill: "url(#paint42_linear_1133_95138)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M284.259 141.386L288.517 138.976C288.739 138.858 288.91 138.569 288.923 138.334C288.923 138.111 288.752 138.019 288.53 138.15L284.272 140.561C284.05 140.679 283.879 140.967 283.866 141.203C283.866 141.425 284.05 141.517 284.259 141.386Z",
    fill: "url(#paint43_linear_1133_95138)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M289.38 140.468L296.245 136.577C296.467 136.459 296.638 136.171 296.651 135.935C296.651 135.712 296.481 135.621 296.258 135.752L289.393 139.642C289.171 139.76 289 140.049 288.987 140.284C288.987 140.507 289.158 140.599 289.38 140.468Z",
    fill: "url(#paint44_linear_1133_95138)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M281.48 120.714L288.017 117.007C288.24 116.889 288.41 116.601 288.423 116.365C288.423 116.142 288.253 116.05 288.03 116.181L281.494 119.889C281.271 120.007 281.101 120.295 281.087 120.531C281.087 120.753 281.258 120.845 281.48 120.714Z",
    fill: "url(#paint45_linear_1133_95138)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M268.892 113.588C268.892 113.561 268.892 113.548 268.892 113.522C268.892 113.496 268.892 113.483 268.892 113.457C268.892 113.43 268.892 113.417 268.905 113.391C268.905 113.365 268.905 113.352 268.918 113.326C268.918 113.299 268.931 113.286 268.931 113.26C268.931 113.234 268.945 113.208 268.945 113.195C268.945 113.168 268.958 113.142 268.958 113.129C268.958 113.103 268.971 113.077 268.971 113.064C268.971 113.037 268.984 113.024 268.984 112.998V112.985C268.997 112.959 268.997 112.933 269.01 112.919C269.023 112.893 269.023 112.88 269.036 112.854C269.049 112.828 269.049 112.815 269.062 112.788C269.076 112.762 269.076 112.749 269.089 112.723C269.102 112.697 269.102 112.684 269.115 112.657C269.128 112.631 269.128 112.618 269.141 112.592C269.154 112.566 269.167 112.54 269.18 112.526C269.193 112.5 269.207 112.474 269.22 112.448C269.233 112.422 269.259 112.382 269.272 112.356C269.272 112.356 269.272 112.356 269.272 112.343C269.272 112.33 269.285 112.33 269.285 112.317C269.311 112.264 269.351 112.212 269.39 112.16C269.416 112.12 269.442 112.081 269.482 112.042C269.495 112.016 269.521 111.989 269.547 111.963C269.56 111.937 269.586 111.924 269.6 111.898C269.613 111.871 269.639 111.858 269.652 111.832C269.665 111.819 269.691 111.793 269.704 111.78V111.767C269.717 111.754 269.731 111.74 269.744 111.727C269.757 111.714 269.783 111.688 269.796 111.675C269.809 111.662 269.835 111.636 269.848 111.623C269.875 111.609 269.888 111.583 269.914 111.57C269.94 111.557 269.953 111.531 269.979 111.518C269.993 111.505 270.019 111.492 270.032 111.478C270.045 111.465 270.071 111.452 270.084 111.439C270.097 111.426 270.124 111.413 270.137 111.4C270.15 111.387 270.176 111.374 270.189 111.361C270.189 111.361 270.202 111.361 270.202 111.347C270.215 111.334 270.228 111.334 270.241 111.321C270.255 111.308 270.281 111.308 270.294 111.295C270.307 111.282 270.333 111.282 270.346 111.269C270.359 111.256 270.386 111.256 270.399 111.243C270.412 111.23 270.438 111.23 270.451 111.216C270.464 111.216 270.49 111.203 270.503 111.203C270.517 111.203 270.543 111.19 270.556 111.19C270.569 111.19 270.595 111.177 270.608 111.177C270.634 111.177 270.648 111.164 270.661 111.164C270.674 111.164 270.687 111.164 270.7 111.164H270.713C270.739 111.164 270.752 111.164 270.779 111.164C270.805 111.164 270.831 111.164 270.844 111.164C270.87 111.164 270.896 111.164 270.923 111.177C270.949 111.177 270.988 111.19 271.014 111.203C271.054 111.216 271.093 111.23 271.119 111.256L272.272 111.924C272.154 111.858 272.01 111.819 271.84 111.832C271.682 111.845 271.499 111.911 271.316 112.016C271.132 112.12 270.949 112.264 270.792 112.435C270.634 112.605 270.49 112.802 270.372 113.011C270.372 113.011 270.372 113.011 270.372 113.024C270.255 113.234 270.15 113.457 270.084 113.679C270.019 113.902 269.979 114.125 269.979 114.334C269.979 114.544 270.019 114.727 270.084 114.871C270.15 115.015 270.255 115.12 270.372 115.199L269.22 114.531C269.128 114.478 269.049 114.4 268.984 114.308C268.971 114.282 268.945 114.243 268.931 114.216C268.918 114.19 268.905 114.164 268.905 114.151C268.892 114.125 268.892 114.098 268.879 114.085C268.866 114.059 268.866 114.046 268.866 114.02C268.866 113.994 268.853 113.981 268.853 113.954C268.853 113.928 268.84 113.915 268.84 113.889C268.84 113.863 268.84 113.85 268.827 113.823C268.827 113.797 268.827 113.784 268.827 113.758C268.827 113.732 268.827 113.719 268.827 113.692C268.892 113.627 268.892 113.601 268.892 113.588Z",
    fill: "#9097C4"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M271.382 111.99C270.648 112.422 270.045 113.457 270.045 114.308C270.045 115.16 270.648 115.5 271.395 115.081C272.128 114.649 272.731 113.614 272.731 112.762C272.731 111.911 272.128 111.557 271.382 111.99Z",
    fill: "url(#paint46_linear_1133_95138)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M307.72 91.4743C307.72 91.4481 307.72 91.435 307.72 91.4088C307.72 91.3826 307.72 91.3695 307.72 91.3433C307.72 91.3171 307.72 91.304 307.733 91.2778C307.733 91.2516 307.733 91.2385 307.747 91.2123C307.747 91.1861 307.76 91.173 307.76 91.1468C307.76 91.1206 307.773 91.0944 307.773 91.0813C307.773 91.0551 307.786 91.0289 307.786 91.0158C307.786 90.9896 307.799 90.9634 307.799 90.9503C307.799 90.9241 307.812 90.911 307.812 90.8848V90.8717C307.825 90.8455 307.825 90.8193 307.838 90.8062C307.851 90.78 307.851 90.7669 307.864 90.7407C307.878 90.7145 307.878 90.7014 307.891 90.6752C307.904 90.649 307.904 90.6359 307.917 90.6097C307.93 90.5835 307.93 90.5704 307.943 90.5442C307.956 90.518 307.956 90.5049 307.969 90.4787C307.982 90.4525 307.995 90.4263 308.009 90.4132C308.022 90.387 308.035 90.3608 308.048 90.3346C308.061 90.3084 308.087 90.2691 308.1 90.2429C308.1 90.2429 308.1 90.2429 308.1 90.2298C308.1 90.2167 308.113 90.2167 308.113 90.2036C308.14 90.1512 308.179 90.0988 308.218 90.0464C308.244 90.0071 308.271 89.9678 308.31 89.9285C308.323 89.9023 308.349 89.8761 308.375 89.8499C308.388 89.8237 308.415 89.8106 308.428 89.7844C308.441 89.7582 308.467 89.7451 308.48 89.7189C308.493 89.7058 308.519 89.6796 308.533 89.6665V89.6534C308.546 89.6403 308.559 89.6272 308.572 89.6141C308.585 89.601 308.611 89.5748 308.624 89.5617C308.637 89.5486 308.664 89.5224 308.69 89.5093C308.716 89.4962 308.729 89.47 308.755 89.4569C308.781 89.4438 308.795 89.4176 308.821 89.4045C308.834 89.3914 308.86 89.3783 308.873 89.3652C308.886 89.3521 308.912 89.339 308.926 89.3259C308.939 89.3128 308.965 89.2997 308.978 89.2866C308.991 89.2735 309.017 89.2604 309.03 89.2473C309.03 89.2473 309.043 89.2473 309.043 89.2342C309.057 89.2211 309.07 89.2211 309.083 89.208C309.096 89.1949 309.122 89.1949 309.135 89.1818C309.148 89.1687 309.174 89.1687 309.188 89.1556C309.201 89.1425 309.227 89.1425 309.24 89.1294C309.253 89.1163 309.279 89.1163 309.292 89.1032C309.305 89.1032 309.332 89.0901 309.345 89.0901C309.358 89.0901 309.384 89.077 309.397 89.077C309.41 89.077 309.436 89.0639 309.45 89.0639C309.476 89.0639 309.489 89.0508 309.502 89.0508C309.515 89.0508 309.528 89.0508 309.541 89.0508H309.554C309.581 89.0508 309.594 89.0508 309.62 89.0508C309.646 89.0508 309.672 89.0508 309.685 89.0508C309.712 89.0508 309.738 89.0508 309.764 89.0639C309.79 89.0639 309.829 89.077 309.856 89.0901C309.895 89.1032 309.934 89.1163 309.96 89.1425L311.113 89.8106C310.995 89.7451 310.851 89.7058 310.681 89.7189C310.524 89.732 310.34 89.7975 310.157 89.9023C309.974 90.0071 309.79 90.1512 309.633 90.3215C309.476 90.4918 309.332 90.6883 309.214 90.8979C309.214 90.8979 309.214 90.8979 309.214 90.911C309.096 91.1206 308.991 91.3433 308.926 91.566C308.86 91.7887 308.821 92.0114 308.821 92.221C308.821 92.4306 308.86 92.614 308.926 92.7581C308.991 92.9022 309.096 93.007 309.214 93.0856L308.061 92.4175C307.969 92.3651 307.891 92.2865 307.825 92.1948C307.812 92.1686 307.786 92.1293 307.773 92.1031C307.76 92.0769 307.747 92.0507 307.747 92.0376C307.733 92.0114 307.733 91.9852 307.72 91.9721C307.707 91.9459 307.707 91.9328 307.707 91.9066C307.707 91.8804 307.694 91.8673 307.694 91.8411C307.694 91.8149 307.681 91.8018 307.681 91.7756C307.681 91.7494 307.681 91.7363 307.668 91.7101C307.668 91.6839 307.668 91.6708 307.668 91.6446C307.668 91.6184 307.668 91.6053 307.668 91.5791C307.72 91.5136 307.72 91.4874 307.72 91.4743Z",
    fill: "#9097C4"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M310.21 89.8744C309.477 90.3067 308.874 91.3416 308.874 92.1931C308.874 93.0446 309.477 93.3852 310.223 92.966C310.957 92.5337 311.56 91.4988 311.56 90.6473C311.56 89.7958 310.957 89.4552 310.21 89.8744Z",
    fill: "url(#paint47_linear_1133_95138)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M268.892 170.127C268.892 170.1 268.892 170.087 268.892 170.061C268.892 170.035 268.892 170.022 268.892 169.996C268.892 169.969 268.892 169.956 268.905 169.93C268.905 169.904 268.905 169.891 268.918 169.865C268.918 169.838 268.931 169.825 268.931 169.799C268.931 169.773 268.945 169.747 268.945 169.734C268.945 169.707 268.958 169.681 268.958 169.668C268.958 169.642 268.971 169.616 268.971 169.603C268.971 169.576 268.984 169.563 268.984 169.537V169.524C268.997 169.498 268.997 169.472 269.01 169.459C269.023 169.432 269.023 169.419 269.036 169.393C269.049 169.367 269.049 169.354 269.062 169.328C269.076 169.301 269.076 169.288 269.089 169.262C269.102 169.236 269.102 169.223 269.115 169.197C269.128 169.17 269.128 169.157 269.141 169.131C269.154 169.105 269.167 169.079 269.18 169.066C269.193 169.039 269.207 169.013 269.22 168.987C269.233 168.961 269.259 168.921 269.272 168.895C269.272 168.895 269.272 168.895 269.272 168.882C269.272 168.869 269.285 168.869 269.285 168.856C269.311 168.804 269.351 168.751 269.39 168.699C269.416 168.659 269.442 168.62 269.482 168.581C269.495 168.555 269.521 168.528 269.547 168.502C269.56 168.476 269.586 168.463 269.6 168.437C269.613 168.411 269.639 168.397 269.652 168.371C269.665 168.358 269.691 168.332 269.704 168.319V168.306C269.717 168.293 269.731 168.28 269.744 168.266C269.757 168.253 269.783 168.227 269.796 168.214C269.809 168.201 269.835 168.175 269.848 168.162C269.875 168.149 269.888 168.122 269.914 168.109C269.94 168.096 269.953 168.07 269.979 168.057C269.993 168.044 270.019 168.031 270.032 168.018C270.045 168.004 270.071 167.991 270.084 167.978C270.097 167.965 270.124 167.952 270.137 167.939C270.15 167.926 270.176 167.913 270.189 167.9C270.189 167.9 270.202 167.9 270.202 167.887C270.215 167.873 270.228 167.873 270.241 167.86C270.255 167.847 270.281 167.847 270.294 167.834C270.307 167.821 270.333 167.821 270.346 167.808C270.359 167.795 270.386 167.795 270.399 167.782C270.412 167.769 270.438 167.769 270.451 167.756C270.464 167.756 270.49 167.742 270.503 167.742C270.517 167.742 270.543 167.729 270.556 167.729C270.569 167.729 270.595 167.716 270.608 167.716C270.634 167.716 270.648 167.703 270.661 167.703C270.674 167.703 270.687 167.703 270.7 167.703H270.713C270.739 167.703 270.752 167.703 270.779 167.703C270.805 167.703 270.831 167.703 270.844 167.703C270.87 167.703 270.896 167.703 270.923 167.716C270.949 167.716 270.988 167.729 271.014 167.742C271.054 167.756 271.093 167.769 271.119 167.795L272.272 168.463C272.154 168.397 272.01 168.358 271.84 168.371C271.682 168.384 271.499 168.45 271.316 168.555C271.132 168.659 270.949 168.804 270.792 168.974C270.634 169.144 270.49 169.341 270.372 169.55C270.372 169.55 270.372 169.55 270.372 169.563C270.255 169.773 270.15 169.996 270.084 170.218C270.019 170.441 269.979 170.664 269.979 170.873C269.979 171.083 270.019 171.266 270.084 171.41C270.15 171.555 270.255 171.659 270.372 171.738L269.22 171.07C269.128 171.017 269.049 170.939 268.984 170.847C268.971 170.821 268.945 170.782 268.931 170.755C268.918 170.729 268.905 170.703 268.905 170.69C268.892 170.664 268.892 170.638 268.879 170.624C268.866 170.598 268.866 170.585 268.866 170.559C268.866 170.533 268.853 170.52 268.853 170.493C268.853 170.467 268.84 170.454 268.84 170.428C268.84 170.402 268.84 170.389 268.827 170.362C268.827 170.336 268.827 170.323 268.827 170.297C268.827 170.271 268.827 170.258 268.827 170.231C268.892 170.179 268.892 170.153 268.892 170.127Z",
    fill: "#9097C4"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M271.382 168.544C270.648 168.976 270.045 170.011 270.045 170.863C270.045 171.714 270.648 172.055 271.395 171.636C272.128 171.203 272.731 170.169 272.731 169.317C272.731 168.466 272.128 168.112 271.382 168.544Z",
    fill: "url(#paint48_linear_1133_95138)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M307.72 148.029C307.72 148.003 307.72 147.99 307.72 147.963C307.72 147.937 307.72 147.924 307.72 147.898C307.72 147.872 307.72 147.859 307.733 147.832C307.733 147.806 307.733 147.793 307.747 147.767C307.747 147.741 307.76 147.728 307.76 147.701C307.76 147.675 307.773 147.649 307.773 147.636C307.773 147.61 307.786 147.584 307.786 147.57C307.786 147.544 307.799 147.518 307.799 147.505C307.799 147.479 307.812 147.466 307.812 147.439V147.426C307.825 147.4 307.825 147.374 307.838 147.361C307.851 147.335 307.851 147.322 307.864 147.295C307.878 147.269 307.878 147.256 307.891 147.23C307.904 147.204 307.904 147.191 307.917 147.164C307.93 147.138 307.93 147.125 307.943 147.099C307.956 147.073 307.956 147.06 307.969 147.033C307.982 147.007 307.995 146.981 308.009 146.968C308.022 146.942 308.035 146.915 308.048 146.889C308.061 146.863 308.087 146.824 308.1 146.798C308.1 146.798 308.1 146.798 308.1 146.784C308.1 146.771 308.113 146.771 308.113 146.758C308.14 146.706 308.179 146.653 308.218 146.601C308.244 146.562 308.271 146.522 308.31 146.483C308.323 146.457 308.349 146.431 308.375 146.405C308.388 146.378 308.415 146.365 308.428 146.339C308.441 146.313 308.467 146.3 308.48 146.274C308.493 146.26 308.519 146.234 308.533 146.221V146.208C308.546 146.195 308.559 146.182 308.572 146.169C308.585 146.156 308.611 146.129 308.624 146.116C308.637 146.103 308.664 146.077 308.69 146.064C308.716 146.051 308.729 146.025 308.755 146.012C308.781 145.998 308.795 145.972 308.821 145.959C308.834 145.946 308.86 145.933 308.873 145.92C308.886 145.907 308.912 145.894 308.926 145.881C308.939 145.867 308.965 145.854 308.978 145.841C308.991 145.828 309.017 145.815 309.03 145.802C309.03 145.802 309.043 145.802 309.043 145.789C309.057 145.776 309.07 145.776 309.083 145.763C309.096 145.75 309.122 145.75 309.135 145.736C309.148 145.723 309.174 145.723 309.188 145.71C309.201 145.697 309.227 145.697 309.24 145.684C309.253 145.671 309.279 145.671 309.292 145.658C309.305 145.658 309.332 145.645 309.345 145.645C309.358 145.645 309.384 145.632 309.397 145.632C309.41 145.632 309.436 145.619 309.45 145.619C309.476 145.619 309.489 145.605 309.502 145.605C309.515 145.605 309.528 145.605 309.541 145.605H309.554C309.581 145.605 309.594 145.605 309.62 145.605C309.646 145.605 309.672 145.605 309.685 145.605C309.712 145.605 309.738 145.605 309.764 145.619C309.79 145.619 309.829 145.632 309.856 145.645C309.895 145.658 309.934 145.671 309.96 145.697L311.113 146.365C310.995 146.3 310.851 146.26 310.681 146.274C310.524 146.287 310.34 146.352 310.157 146.457C309.974 146.562 309.79 146.706 309.633 146.876C309.476 147.046 309.332 147.243 309.214 147.453C309.214 147.453 309.214 147.453 309.214 147.466C309.096 147.675 308.991 147.898 308.926 148.121C308.86 148.343 308.821 148.566 308.821 148.776C308.821 148.985 308.86 149.169 308.926 149.313C308.991 149.457 309.096 149.562 309.214 149.64L308.061 148.972C307.969 148.92 307.891 148.841 307.825 148.749C307.812 148.723 307.786 148.684 307.773 148.658C307.76 148.632 307.747 148.605 307.747 148.592C307.733 148.566 307.733 148.54 307.72 148.527C307.707 148.501 307.707 148.487 307.707 148.461C307.707 148.435 307.694 148.422 307.694 148.396C307.694 148.37 307.681 148.356 307.681 148.33C307.681 148.304 307.681 148.291 307.668 148.265C307.668 148.239 307.668 148.225 307.668 148.199C307.668 148.173 307.668 148.16 307.668 148.134C307.72 148.068 307.72 148.042 307.72 148.029Z",
    fill: "#9097C4"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M310.21 146.429C309.476 146.861 308.874 147.896 308.874 148.748C308.874 149.599 309.476 149.94 310.223 149.521C310.97 149.101 311.559 148.053 311.559 147.202C311.559 146.35 310.956 146.01 310.21 146.429Z",
    fill: "url(#paint49_linear_1133_95138)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M250.632 100.597L250.475 193.306L199.778 164.041L199.935 71.332L250.632 100.597Z",
    fill: "#232D6C"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M202.66 162.255L250.632 190V170.901L202.66 143.168V162.255Z",
    fill: "url(#paint50_linear_1133_95138)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M205.596 161.038L221.473 170.208V156.217L205.596 147.047V161.038Z",
    fill: "url(#paint51_linear_1133_95138)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M208.072 148.475V160.199L205.596 161.038V147.047L208.072 148.475Z",
    fill: "#232D6C"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M208.072 160.195L221.473 167.689V170.204L205.596 161.034L208.072 160.195Z",
    fill: "#425CFF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M212.629 160.367L211.306 159.62V158.074L212.629 158.834V160.367Z",
    fill: "url(#paint52_linear_1133_95138)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M214.844 161.652L213.521 160.905V159.359L214.844 160.119V161.652Z",
    fill: "url(#paint53_linear_1133_95138)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M217.057 162.937L215.734 162.19V160.645L217.057 161.404V162.937Z",
    fill: "url(#paint54_linear_1133_95138)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M212.629 157.437L211.306 156.69V155.145L212.629 155.904V157.437Z",
    fill: "url(#paint55_linear_1133_95138)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M214.844 158.718L213.521 157.972V156.426L214.844 157.186V158.718Z",
    fill: "url(#paint56_linear_1133_95138)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M217.057 160L215.734 159.253V157.707L217.057 158.467V160Z",
    fill: "url(#paint57_linear_1133_95138)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M212.629 154.515L211.306 153.755V152.223L212.629 152.969V154.515Z",
    fill: "url(#paint58_linear_1133_95138)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M214.844 155.796L213.521 155.037V153.504L214.844 154.251V155.796Z",
    fill: "url(#paint59_linear_1133_95138)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M217.057 157.078L215.734 156.318V154.785L217.057 155.532V157.078Z",
    fill: "url(#paint60_linear_1133_95138)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M240.65 169.828L235.633 166.854C235.397 166.723 235.213 166.422 235.213 166.186C235.213 165.95 235.397 165.885 235.633 166.016L240.65 168.989C240.886 169.12 241.069 169.422 241.069 169.658C241.069 169.893 240.886 169.959 240.65 169.828Z",
    fill: "url(#paint61_linear_1133_95138)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M247.594 173.941L242.577 170.967C242.341 170.836 242.158 170.535 242.158 170.299C242.158 170.064 242.341 169.998 242.577 170.129L247.594 173.103C247.83 173.234 248.013 173.535 248.013 173.771C248.013 173.994 247.83 174.072 247.594 173.941Z",
    fill: "url(#paint62_linear_1133_95138)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M202.661 139.829L250.633 167.575V148.475L202.661 120.742V139.829Z",
    fill: "url(#paint63_linear_1133_95138)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M205.596 138.599L221.473 147.769V133.791L205.596 124.621V138.599Z",
    fill: "url(#paint64_linear_1133_95138)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M208.072 126.049V137.773L205.596 138.599V124.621L208.072 126.049Z",
    fill: "#232D6C"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M208.072 137.77L221.473 145.263V147.765L205.596 138.595L208.072 137.77Z",
    fill: "#425CFF"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M212.63 137.945L211.307 137.185V135.652L212.63 136.412V137.945Z",
    fill: "url(#paint65_linear_1133_95138)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M214.844 139.23L213.521 138.47V136.938L214.844 137.697V139.23Z",
    fill: "url(#paint66_linear_1133_95138)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M217.057 140.511L215.734 139.751V138.219L217.057 138.979V140.511Z",
    fill: "url(#paint67_linear_1133_95138)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M212.63 135.011L211.307 134.265V132.719L212.63 133.479V135.011Z",
    fill: "url(#paint68_linear_1133_95138)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M214.844 136.289L213.521 135.542V133.996L214.844 134.756V136.289Z",
    fill: "url(#paint69_linear_1133_95138)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M217.057 137.574L215.734 136.827V135.281L217.057 136.041V137.574Z",
    fill: "url(#paint70_linear_1133_95138)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M212.63 132.085L211.307 131.326V129.793L212.63 130.54V132.085Z",
    fill: "url(#paint71_linear_1133_95138)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M214.844 133.371L213.521 132.611V131.078L214.844 131.825V133.371Z",
    fill: "url(#paint72_linear_1133_95138)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M217.057 134.652L215.734 133.892V132.359L217.057 133.106V134.652Z",
    fill: "url(#paint73_linear_1133_95138)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M240.65 147.402L235.633 144.428C235.397 144.297 235.214 143.996 235.214 143.76C235.214 143.524 235.397 143.459 235.633 143.59L240.65 146.564C240.886 146.695 241.07 146.996 241.07 147.232C241.07 147.454 240.886 147.533 240.65 147.402Z",
    fill: "url(#paint74_linear_1133_95138)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M247.593 151.515L242.575 148.542C242.34 148.411 242.156 148.109 242.156 147.874C242.156 147.638 242.34 147.572 242.575 147.703L247.593 150.677C247.829 150.808 248.012 151.109 248.012 151.345C248.012 151.568 247.829 151.646 247.593 151.515Z",
    fill: "url(#paint75_linear_1133_95138)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M202.661 117.397L250.633 145.129V126.043L202.661 98.2969V117.397Z",
    fill: "url(#paint76_linear_1133_95138)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M205.596 116.165L221.473 125.335V111.358L205.596 102.188V116.165Z",
    fill: "url(#paint77_linear_1133_95138)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M208.072 103.615V115.34L205.596 116.165V102.188L208.072 103.615Z",
    fill: "#232D6C"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M208.072 115.34L221.473 122.833V125.335L205.596 116.165L208.072 115.34Z",
    fill: "#425CFF"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M212.63 115.507L211.307 114.748V113.215L212.63 113.962V115.507Z",
    fill: "url(#paint78_linear_1133_95138)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M214.844 116.792L213.521 116.033V114.5L214.844 115.247V116.792Z",
    fill: "url(#paint79_linear_1133_95138)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M217.057 118.082L215.734 117.322V115.789L217.057 116.536V118.082Z",
    fill: "url(#paint80_linear_1133_95138)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M212.63 112.574L211.307 111.814V110.281L212.63 111.041V112.574Z",
    fill: "url(#paint81_linear_1133_95138)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M214.844 113.859L213.521 113.099V111.566L214.844 112.326V113.859Z",
    fill: "url(#paint82_linear_1133_95138)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M217.057 115.144L215.734 114.384V112.852L217.057 113.611V115.144Z",
    fill: "url(#paint83_linear_1133_95138)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M212.63 109.64L211.307 108.893V107.348L212.63 108.107V109.64Z",
    fill: "url(#paint84_linear_1133_95138)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M214.844 110.925L213.521 110.179V108.633L214.844 109.393V110.925Z",
    fill: "url(#paint85_linear_1133_95138)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M217.057 112.207L215.734 111.46V109.914L217.057 110.674V112.207Z",
    fill: "url(#paint86_linear_1133_95138)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M240.65 124.968L235.633 121.995C235.397 121.864 235.214 121.562 235.214 121.327C235.214 121.091 235.397 121.025 235.633 121.156L240.65 124.13C240.886 124.261 241.07 124.562 241.07 124.798C241.07 125.021 240.886 125.099 240.65 124.968Z",
    fill: "url(#paint87_linear_1133_95138)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M247.593 129.082L242.575 126.108C242.34 125.977 242.156 125.676 242.156 125.44C242.156 125.204 242.34 125.139 242.575 125.27L247.593 128.243C247.829 128.374 248.012 128.676 248.012 128.911C248.012 129.134 247.829 129.213 247.593 129.082Z",
    fill: "url(#paint88_linear_1133_95138)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M202.661 94.9748L250.633 122.708V103.621L202.661 75.875V94.9748Z",
    fill: "url(#paint89_linear_1133_95138)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M205.596 93.7447L221.473 102.915V88.9239L205.596 79.7539V93.7447Z",
    fill: "url(#paint90_linear_1133_95138)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M208.072 81.1818V92.9063L205.596 93.7447V79.7539L208.072 81.1818Z",
    fill: "#232D6C"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M208.072 92.9023L221.473 100.396V102.911L205.596 93.7407L208.072 92.9023Z",
    fill: "#425CFF"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M212.63 93.0855L211.307 92.3257V90.793L212.63 91.5397V93.0855Z",
    fill: "url(#paint91_linear_1133_95138)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M214.844 94.3706L213.521 93.6108V92.0781L214.844 92.8248V94.3706Z",
    fill: "url(#paint92_linear_1133_95138)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M217.057 95.6597L215.734 94.8999V93.3672L217.057 94.1139V95.6597Z",
    fill: "url(#paint93_linear_1133_95138)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M212.63 90.1519L211.307 89.3921V87.8594L212.63 88.6061V90.1519Z",
    fill: "url(#paint94_linear_1133_95138)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M214.844 91.437L213.521 90.6772V89.1445L214.844 89.8912V91.437Z",
    fill: "url(#paint95_linear_1133_95138)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M217.057 92.7222L215.734 91.9624V90.4297L217.057 91.1764V92.7222Z",
    fill: "url(#paint96_linear_1133_95138)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M212.63 87.2183L211.307 86.4716V84.9258L212.63 85.6856V87.2183Z",
    fill: "url(#paint97_linear_1133_95138)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M214.844 88.5034L213.521 87.7567V86.2109L214.844 86.9707V88.5034Z",
    fill: "url(#paint98_linear_1133_95138)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M217.057 89.7847L215.734 89.038V87.4922L217.057 88.252V89.7847Z",
    fill: "url(#paint99_linear_1133_95138)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M240.65 102.547L235.633 99.5729C235.397 99.4419 235.214 99.1406 235.214 98.9048C235.214 98.669 235.397 98.6035 235.633 98.7345L240.65 101.708C240.886 101.839 241.07 102.14 241.07 102.376C241.07 102.599 240.886 102.678 240.65 102.547Z",
    fill: "url(#paint100_linear_1133_95138)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M247.593 106.648L242.575 103.674C242.34 103.543 242.156 103.242 242.156 103.006C242.156 102.771 242.34 102.705 242.575 102.836L247.593 105.81C247.829 105.941 248.012 106.242 248.012 106.478C248.012 106.714 247.829 106.792 247.593 106.648Z",
    fill: "url(#paint101_linear_1133_95138)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M143.933 101.009V194.059L145.924 195.224L197.944 163.221V70.1719L143.933 101.009ZM195.363 161.728L146.513 189.605V102.503L195.363 74.6259V161.728Z",
    fill: "url(#paint102_linear_1133_95138)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M145.924 102.177V195.227L199.935 164.389V71.3398L145.924 102.177ZM197.354 162.883L148.505 190.759V103.658L197.354 75.7807V162.883Z",
    fill: "url(#paint103_linear_1133_95138)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M197.944 70.1719L199.935 71.3378L145.924 102.175L143.933 101.009L197.944 70.1719Z",
    fill: "url(#paint104_linear_1133_95138)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M195.363 161.727L197.354 162.879L148.504 190.756V188.359L195.363 161.727Z",
    fill: "url(#paint105_linear_1133_95138)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M148.504 103.659L196.463 76.5156V162.373L148.504 190.014V103.659Z",
    fill: "url(#paint106_linear_1133_95138)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M148.504 146.253L196.463 82.7969V92.4647L148.504 155.934V146.253Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M148.504 161.559L196.463 98.0898V107.771L148.504 171.227V161.559Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M223.894 248.953V267.752L154.936 307.497V288.699L223.894 248.953Z",
    fill: "url(#paint107_linear_1133_95138)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M154.936 288.701V307.5L67.9521 257.209V238.41L154.936 288.701Z",
    fill: "url(#paint108_linear_1133_95138)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M223.895 248.955L154.936 288.7L67.9521 238.409L136.911 198.664L223.895 248.955Z",
    fill: "url(#paint109_linear_1133_95138)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M154.936 288.231L68.3451 238.176L67.9521 238.412L154.936 288.702L223.895 248.957L223.502 248.721L154.936 288.231Z",
    fill: "url(#paint110_linear_1133_95138)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M143.342 255.097C143.342 255.097 142.923 259.368 143.342 259.63C143.761 259.879 148.071 262.42 149.84 261.241C151.621 260.062 152.695 257.18 156.547 254.141C160.398 251.102 159.141 248.22 156.18 248.39C153.219 248.56 151.058 250.08 151.058 250.08L143.342 255.097Z",
    fill: "url(#paint111_linear_1133_95138)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M128.945 248.645C128.945 248.645 127.687 252.091 128.12 252.85C128.539 253.61 133.15 256.44 134.565 255.575C135.98 254.711 143.29 246.432 142.464 244.06C141.652 241.689 138.94 241.532 136.569 244.06C134.198 246.602 128.945 248.645 128.945 248.645Z",
    fill: "url(#paint112_linear_1133_95138)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M182.052 132.557L182.025 159.058C182.025 159.687 180.715 160.565 180.165 160.25L168.729 152.783C168.153 152.456 167.799 151.84 167.799 151.172L167.118 124.789C167.118 124.094 168.585 123.636 169.187 123.989L181.069 130.841C181.685 131.194 182.052 131.849 182.052 132.557Z",
    fill: "url(#paint113_linear_1133_95138)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M181.122 133.014L181.096 159.516C181.096 160.144 180.415 160.524 179.877 160.223L167.799 153.254C167.223 152.926 166.869 152.311 166.869 151.642L166.895 125.233C166.895 124.539 167.655 124.106 168.258 124.447L180.139 131.298C180.742 131.652 181.122 132.307 181.122 133.014Z",
    fill: "url(#paint114_linear_1133_95138)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M180.558 133.017L180.532 150.702L180.519 159.518C180.519 159.675 180.388 159.78 180.27 159.78C180.231 159.78 180.192 159.767 180.152 159.741L168.074 152.771C167.668 152.536 167.432 152.116 167.432 151.645V150.086L167.458 125.235C167.458 125.026 167.642 124.895 167.812 124.895C167.878 124.895 167.93 124.908 167.982 124.947L171.506 126.977L179.864 131.798C180.296 132.034 180.558 132.506 180.558 133.017Z",
    fill: "url(#paint115_linear_1133_95138)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M180.14 131.298L168.258 124.446C168.009 124.302 167.734 124.302 167.498 124.381C167.708 124.328 167.93 124.355 168.14 124.472L180.022 131.324C180.637 131.677 181.004 132.332 181.004 133.027L180.978 159.528C180.978 159.895 180.742 160.17 180.454 160.288C180.808 160.209 181.096 159.908 181.096 159.502L181.122 133.001C181.122 132.306 180.742 131.651 180.14 131.298Z",
    fill: "url(#paint116_linear_1133_95138)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M177.676 161.93L163.358 153.572C163.056 153.402 162.873 153.075 162.873 152.734V125.054C162.873 124.713 163.24 124.503 163.528 124.674L177.663 132.914C178.03 133.123 178.252 133.529 178.252 133.949V161.59C178.266 161.904 177.938 162.087 177.676 161.93Z",
    fill: "url(#paint117_linear_1133_95138)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M177.387 139.789L163.763 131.811V125.746L177.387 133.724V139.789Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M177.387 150.872L163.763 142.894V139.344L177.387 147.322V150.872Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M170.208 142.475L163.763 138.702V132.637L170.208 136.41V142.475Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M177.388 146.674L170.943 142.901V136.836L177.388 140.609V146.674Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M176.353 134.774L171.034 131.656C170.903 131.578 170.798 131.408 170.798 131.277C170.798 131.146 170.903 131.106 171.034 131.172L176.353 134.29C176.484 134.368 176.589 134.538 176.589 134.669C176.589 134.8 176.484 134.853 176.353 134.774Z",
    fill: "url(#paint118_linear_1133_95138)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M176.353 135.821L171.034 132.703C170.903 132.625 170.798 132.454 170.798 132.323C170.798 132.192 170.903 132.153 171.034 132.219L176.353 135.336C176.484 135.415 176.589 135.585 176.589 135.716C176.589 135.86 176.484 135.9 176.353 135.821Z",
    fill: "url(#paint119_linear_1133_95138)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M176.353 136.88L171.034 133.762C170.903 133.683 170.798 133.513 170.798 133.382C170.798 133.251 170.903 133.212 171.034 133.277L176.353 136.395C176.484 136.474 176.589 136.644 176.589 136.775C176.589 136.906 176.484 136.958 176.353 136.88Z",
    fill: "url(#paint120_linear_1133_95138)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M175.239 137.285L171.02 134.809C170.889 134.73 170.785 134.56 170.785 134.429C170.785 134.298 170.889 134.259 171.02 134.324L175.239 136.8C175.37 136.879 175.474 137.049 175.474 137.18C175.488 137.324 175.37 137.363 175.239 137.285Z",
    fill: "url(#paint121_linear_1133_95138)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M169.24 137.532L164.76 134.899C164.629 134.82 164.524 134.65 164.524 134.519C164.524 134.388 164.629 134.348 164.76 134.414L169.24 137.047C169.371 137.126 169.476 137.296 169.476 137.427C169.489 137.558 169.371 137.61 169.24 137.532Z",
    fill: "url(#paint122_linear_1133_95138)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M169.24 138.586L164.76 135.953C164.629 135.875 164.524 135.704 164.524 135.573C164.524 135.442 164.629 135.403 164.76 135.469L169.24 138.102C169.371 138.18 169.476 138.351 169.476 138.482C169.489 138.626 169.371 138.665 169.24 138.586Z",
    fill: "url(#paint123_linear_1133_95138)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M169.24 139.645L164.76 137.012C164.629 136.933 164.524 136.763 164.524 136.632C164.524 136.501 164.629 136.462 164.76 136.527L169.24 139.16C169.371 139.239 169.476 139.409 169.476 139.54C169.489 139.671 169.371 139.724 169.24 139.645Z",
    fill: "url(#paint124_linear_1133_95138)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M168.297 140.14L164.76 138.07C164.629 137.992 164.524 137.822 164.524 137.691C164.524 137.56 164.629 137.52 164.76 137.586L168.297 139.656C168.428 139.734 168.533 139.904 168.533 140.035C168.546 140.18 168.428 140.219 168.297 140.14Z",
    fill: "url(#paint125_linear_1133_95138)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M176.536 141.809L172.056 139.176C171.925 139.097 171.82 138.927 171.82 138.796C171.82 138.665 171.925 138.626 172.056 138.691L176.536 141.324C176.667 141.403 176.772 141.573 176.772 141.704C176.785 141.848 176.68 141.888 176.536 141.809Z",
    fill: "url(#paint126_linear_1133_95138)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M176.536 142.868L172.056 140.235C171.925 140.156 171.82 139.986 171.82 139.855C171.82 139.724 171.925 139.684 172.056 139.75L176.536 142.383C176.667 142.462 176.772 142.632 176.772 142.763C176.785 142.894 176.68 142.946 176.536 142.868Z",
    fill: "url(#paint127_linear_1133_95138)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M176.536 143.915L172.056 141.281C171.925 141.203 171.82 141.033 171.82 140.902C171.82 140.771 171.925 140.731 172.056 140.797L176.536 143.43C176.667 143.508 176.772 143.679 176.772 143.81C176.785 143.954 176.68 143.993 176.536 143.915Z",
    fill: "url(#paint128_linear_1133_95138)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M175.593 144.425L172.056 142.356C171.925 142.277 171.82 142.107 171.82 141.976C171.82 141.845 171.925 141.805 172.056 141.871L175.593 143.941C175.724 144.019 175.828 144.19 175.828 144.321C175.842 144.452 175.737 144.504 175.593 144.425Z",
    fill: "url(#paint129_linear_1133_95138)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M169.501 143.735L165.02 141.102C164.889 141.023 164.785 140.853 164.785 140.722C164.785 140.591 164.889 140.552 165.02 140.617L169.501 143.25C169.632 143.329 169.736 143.499 169.736 143.63C169.736 143.761 169.632 143.813 169.501 143.735Z",
    fill: "url(#paint130_linear_1133_95138)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M169.501 144.774L165.02 142.141C164.889 142.062 164.785 141.892 164.785 141.761C164.785 141.63 164.889 141.591 165.02 141.656L169.501 144.289C169.632 144.368 169.736 144.538 169.736 144.669C169.736 144.813 169.632 144.853 169.501 144.774Z",
    fill: "url(#paint131_linear_1133_95138)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M168.557 145.289L165.02 143.219C164.889 143.14 164.785 142.97 164.785 142.839C164.785 142.708 164.889 142.669 165.02 142.734L168.557 144.804C168.688 144.883 168.793 145.053 168.793 145.184C168.793 145.315 168.688 145.367 168.557 145.289Z",
    fill: "url(#paint132_linear_1133_95138)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M169.737 134.247L164.628 131.247V127.238L169.737 130.225V134.247Z",
    fill: "url(#paint133_linear_1133_95138)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M176.483 150.073L172.815 147.925V145.043L176.483 147.191V150.073Z",
    fill: "url(#paint134_linear_1133_95138)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M177.387 155.087L163.763 147.109V143.559L177.387 151.536V155.087Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M169.501 147.95L165.02 145.317C164.889 145.238 164.785 145.068 164.785 144.937C164.785 144.806 164.889 144.766 165.02 144.832L169.501 147.465C169.632 147.544 169.736 147.714 169.736 147.845C169.736 147.976 169.632 148.028 169.501 147.95Z",
    fill: "url(#paint135_linear_1133_95138)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M169.501 149L165.02 146.367C164.889 146.289 164.785 146.118 164.785 145.987C164.785 145.856 164.889 145.817 165.02 145.883L169.501 148.516C169.632 148.594 169.736 148.765 169.736 148.896C169.736 149.04 169.632 149.079 169.501 149Z",
    fill: "url(#paint136_linear_1133_95138)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M168.557 149.511L165.02 147.442C164.889 147.363 164.785 147.193 164.785 147.062C164.785 146.931 164.889 146.891 165.02 146.957L168.557 149.027C168.688 149.105 168.793 149.276 168.793 149.407C168.793 149.538 168.688 149.59 168.557 149.511Z",
    fill: "url(#paint137_linear_1133_95138)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M176.483 154.288L172.815 152.14V149.258L176.483 151.406V154.288Z",
    fill: "url(#paint138_linear_1133_95138)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M177.387 159.309L163.763 151.331V147.781L177.387 155.759V159.309Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M169.501 152.168L165.02 149.535C164.889 149.457 164.785 149.286 164.785 149.155C164.785 149.024 164.889 148.985 165.02 149.051L169.501 151.684C169.632 151.762 169.736 151.933 169.736 152.064C169.736 152.195 169.632 152.247 169.501 152.168Z",
    fill: "url(#paint139_linear_1133_95138)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M169.501 153.215L165.02 150.582C164.889 150.504 164.785 150.333 164.785 150.202C164.785 150.071 164.889 150.032 165.02 150.098L169.501 152.731C169.632 152.809 169.736 152.98 169.736 153.111C169.736 153.255 169.632 153.294 169.501 153.215Z",
    fill: "url(#paint140_linear_1133_95138)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M168.557 153.726L165.02 151.656C164.889 151.578 164.785 151.408 164.785 151.277C164.785 151.146 164.889 151.106 165.02 151.172L168.557 153.242C168.688 153.32 168.793 153.49 168.793 153.621C168.793 153.752 168.688 153.805 168.557 153.726Z",
    fill: "url(#paint141_linear_1133_95138)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M176.484 158.511L172.816 156.362V153.48L176.484 155.629V158.511Z",
    fill: "url(#paint142_linear_1133_95138)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M166.514 130.811L166.134 131.374L165.649 131.086L166.894 129.305L167.47 129.645L168.728 132.894L168.217 132.593L167.824 131.571L166.514 130.811ZM167.719 131.27L167.352 130.34C167.274 130.13 167.221 129.947 167.156 129.776L167.143 129.763C167.09 129.881 167.025 129.999 166.959 130.104L166.606 130.615L167.719 131.27Z",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M149.563 128.582C149.563 128.582 150.375 132.224 150.021 132.984C149.667 133.73 149.667 133.73 149.667 133.73C149.667 133.73 150.309 136.39 150.1 137.726C149.903 139.062 148.908 143.398 148.108 143.516C147.296 143.634 145.449 143.11 145.095 143.87C144.742 144.616 144.467 148.284 144.467 148.284L134.118 142.887L135.205 134.215L149.563 128.582Z",
    fill: "url(#paint143_linear_1133_95138)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M126.155 190.145C126.155 190.145 124.95 193.983 126.155 197.664C127.36 201.345 127.74 202.354 127.74 202.354L128.618 220.825C128.618 220.825 127.36 229.628 127.74 236.414C128.12 243.2 128.618 248.23 128.618 248.23C128.618 248.23 129.627 250.3 133.02 249.579C136.413 248.859 137.29 246.213 137.29 246.213C137.29 246.213 134.775 232.759 138.233 224.218C141.692 215.676 142.321 193.682 142.321 193.682L126.155 190.145Z",
    fill: "url(#paint144_linear_1133_95138)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M143.603 150.973L155.039 146.008C155.039 146.008 158 146.702 158.419 148.484C158.838 150.278 158.144 151.588 158.144 151.588L140.092 162.199L143.603 150.973Z",
    fill: "url(#paint145_linear_1133_95138)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M128.197 139.935C125.315 138.494 119.551 144.389 123.088 154.083C126.625 163.777 126.756 174.781 126.756 180.4C126.756 186.033 126.101 187.474 126.101 187.474C126.101 187.474 124.136 195.151 136.45 197.666C148.764 200.181 154.397 192.059 154.397 192.059C154.397 192.059 155.052 156.179 153.218 153.69C151.371 151.201 128.197 139.935 128.197 139.935Z",
    fill: "url(#paint146_linear_1133_95138)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M153.206 153.685C149.76 150.908 144.285 158.82 150.743 169.549C157.201 180.278 159.625 178.666 163.437 175.09C167.249 171.514 174.061 163.313 174.061 163.313C174.061 163.313 174.297 160.313 172.672 158.925C171.061 157.536 169.319 157.654 169.319 157.654C169.319 157.654 161.708 166.772 160.777 166.654C159.86 166.549 154.909 155.06 153.206 153.685Z",
    fill: "url(#paint147_linear_1133_95138)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M134.564 197.202C134.564 197.202 135.311 202.324 138.245 206.044C141.179 209.765 142.332 209.83 142.332 209.83L143.708 225.38C143.708 225.38 141.769 233.829 142.332 241.729C142.896 249.628 142.332 253.23 142.332 253.23C142.332 253.23 142.227 256.021 146.171 255.536C150.114 255.038 151.921 251.92 151.921 251.92C151.921 251.92 151.751 233.869 155.21 225.38C158.668 216.904 154.384 192.066 154.384 192.066C154.384 192.066 146.957 199.861 134.564 197.202Z",
    fill: "url(#paint148_linear_1133_95138)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M150.925 125.941C151.528 128.601 148.501 130.133 147.401 130.133C146.301 130.133 146.301 136.448 146.012 136.749C145.724 137.037 144.768 134.325 143.877 134.247C142.999 134.168 141.965 136.107 142.554 138.635C143.144 141.164 134.773 139.906 133.515 138.295C132.271 136.683 130.214 133.369 130.057 130.88C129.913 128.378 132.257 127.867 132.257 127.867C132.257 127.867 129.611 124.042 134.904 121.33C140.196 118.605 149.523 119.85 150.925 125.941Z",
    fill: "url(#paint149_linear_1133_95138)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M155.956 146.316C155.956 146.316 160.502 142.268 161.746 141.626C162.991 140.984 162.991 140.984 162.991 140.984V144.43C162.991 144.43 164.93 144.482 165.309 144.914C165.689 145.347 164.34 146.748 162.349 147.993C160.358 149.237 158.537 150.102 158.537 150.102C158.537 150.102 157.882 146.853 155.956 146.316Z",
    fill: "url(#paint150_linear_1133_95138)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M170.117 157.723C170.117 157.723 169.908 155.208 170.969 152.876C172.043 150.544 173.117 148.736 173.117 148.736C173.117 148.736 173.956 148.226 174.074 150.505C174.191 152.797 175.043 154.461 176.117 153.793C177.191 153.125 177.008 148.763 177.925 150.073C178.855 151.396 179.693 154.16 178.776 156.046C177.846 157.933 174.074 162.557 174.074 162.557C174.074 162.557 173.916 159.02 170.117 157.723Z",
    fill: "url(#paint151_linear_1133_95138)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1133_95138",
    x1: 287.886,
    y1: 207.574,
    x2: 295.359,
    y2: 221.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1133_95138",
    x1: 213.596,
    y1: 232.205,
    x2: 213.596,
    y2: 193.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525EAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1133_95138",
    x1: 234.146,
    y1: 234.111,
    x2: 252.907,
    y2: 165.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1133_95138",
    x1: 235.13,
    y1: 230.483,
    x2: 248.045,
    y2: 182.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1133_95138",
    x1: 253.026,
    y1: 81.457,
    x2: 315.466,
    y2: 197.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1133_95138",
    x1: 225.204,
    y1: 193.168,
    x2: 225.204,
    y2: 90.8825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525EAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1133_95138",
    x1: 239.192,
    y1: 92.4764,
    x2: 252.824,
    y2: 42.3105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1133_95138",
    x1: 239.974,
    y1: 89.6066,
    x2: 248.965,
    y2: 56.5177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1133_95138",
    x1: 277.712,
    y1: 66.3379,
    x2: 281.049,
    y2: 72.5194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1133_95138",
    x1: 228.443,
    y1: 78.6899,
    x2: 228.443,
    y2: 54.0863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525EAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1133_95138",
    x1: 240.506,
    y1: 81.7347,
    x2: 252.35,
    y2: 38.1469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1133_95138",
    x1: 241.185,
    y1: 79.2364,
    x2: 248.997,
    y2: 50.4863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1133_95138",
    x1: 273.222,
    y1: 100.968,
    x2: 306.02,
    y2: 161.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1133_95138",
    x1: 265.308,
    y1: 176.381,
    x2: 264.981,
    y2: 133.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9097C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1133_95138",
    x1: 280.845,
    y1: 120.359,
    x2: 289.438,
    y2: 88.7382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1133_95138",
    x1: 280.89,
    y1: 120.194,
    x2: 289.212,
    y2: 89.5693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1133_95138",
    x1: 278.031,
    y1: 109.877,
    x2: 301.07,
    y2: 152.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1133_95138",
    x1: 293.471,
    y1: 115.188,
    x2: 292.284,
    y2: 113.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1133_95138",
    x1: 292.322,
    y1: 117.377,
    x2: 291.449,
    y2: 116.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1133_95138",
    x1: 286.372,
    y1: 120.747,
    x2: 285.499,
    y2: 119.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1133_95138",
    x1: 290.29,
    y1: 120.801,
    x2: 289.211,
    y2: 119.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1133_95138",
    x1: 281.979,
    y1: 125.504,
    x2: 280.9,
    y2: 124.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1133_95138",
    x1: 291.577,
    y1: 121.9,
    x2: 290.608,
    y2: 120.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1133_95138",
    x1: 285.308,
    y1: 125.439,
    x2: 284.34,
    y2: 124.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1133_95138",
    x1: 294.12,
    y1: 122.454,
    x2: 293.139,
    y2: 121.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1133_95138",
    x1: 287.383,
    y1: 126.27,
    x2: 286.403,
    y2: 125.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1133_95138",
    x1: 281.826,
    y1: 128.98,
    x2: 281.155,
    y2: 128.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1133_95138",
    x1: 291.876,
    y1: 125.744,
    x2: 290.869,
    y2: 124.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1133_95138",
    x1: 284.928,
    y1: 129.672,
    x2: 283.921,
    y2: 128.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1133_95138",
    x1: 292.408,
    y1: 127.233,
    x2: 291.534,
    y2: 126.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1133_95138",
    x1: 293.458,
    y1: 130.449,
    x2: 292.584,
    y2: 129.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1133_95138",
    x1: 287.543,
    y1: 133.835,
    x2: 286.669,
    y2: 132.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1133_95138",
    x1: 294.531,
    y1: 132.274,
    x2: 293.657,
    y2: 131.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1133_95138",
    x1: 285.932,
    y1: 137.266,
    x2: 285.058,
    y2: 136.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1133_95138",
    x1: 286.701,
    y1: 130.464,
    x2: 285.827,
    y2: 129.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1133_95138",
    x1: 293.226,
    y1: 129.193,
    x2: 292.038,
    y2: 127.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1133_95138",
    x1: 291.876,
    y1: 136.103,
    x2: 290.869,
    y2: 134.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1133_95138",
    x1: 284.928,
    y1: 140.041,
    x2: 283.921,
    y2: 138.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1133_95138",
    x1: 292.409,
    y1: 137.594,
    x2: 291.534,
    y2: 136.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1133_95138",
    x1: 293.458,
    y1: 140.81,
    x2: 292.584,
    y2: 139.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1133_95138",
    x1: 287.543,
    y1: 144.201,
    x2: 286.669,
    y2: 143.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1133_95138",
    x1: 294.531,
    y1: 142.645,
    x2: 293.657,
    y2: 141.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1133_95138",
    x1: 285.932,
    y1: 147.633,
    x2: 285.058,
    y2: 146.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1133_95138",
    x1: 286.701,
    y1: 140.831,
    x2: 285.827,
    y2: 139.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1133_95138",
    x1: 293.226,
    y1: 139.556,
    x2: 292.038,
    y2: 138.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1133_95138",
    x1: 285.15,
    y1: 119.846,
    x2: 284.002,
    y2: 118.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1133_95138",
    x1: 270.048,
    y1: 113.534,
    x2: 272.735,
    y2: 113.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1133_95138",
    x1: 308.876,
    y1: 91.4243,
    x2: 311.563,
    y2: 91.4243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1133_95138",
    x1: 270.048,
    y1: 170.088,
    x2: 272.735,
    y2: 170.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1133_95138",
    x1: 308.875,
    y1: 147.979,
    x2: 311.563,
    y2: 147.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1133_95138",
    x1: 226.485,
    y1: 150.215,
    x2: 226.745,
    y2: 176.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1133_95138",
    x1: 214.069,
    y1: 149.818,
    x2: 213.391,
    y2: 160.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1133_95138",
    x1: 212.013,
    y1: 158.272,
    x2: 211.937,
    y2: 159.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1133_95138",
    x1: 214.225,
    y1: 159.557,
    x2: 214.148,
    y2: 161.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1133_95138",
    x1: 216.436,
    y1: 160.843,
    x2: 216.359,
    y2: 162.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1133_95138",
    x1: 212.013,
    y1: 155.347,
    x2: 211.936,
    y2: 157.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1133_95138",
    x1: 214.225,
    y1: 156.628,
    x2: 214.148,
    y2: 158.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_1133_95138",
    x1: 216.435,
    y1: 157.909,
    x2: 216.359,
    y2: 159.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_1133_95138",
    x1: 212.013,
    y1: 152.416,
    x2: 211.936,
    y2: 154.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_1133_95138",
    x1: 214.225,
    y1: 153.697,
    x2: 214.148,
    y2: 155.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_1133_95138",
    x1: 216.435,
    y1: 154.979,
    x2: 216.359,
    y2: 156.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_1133_95138",
    x1: 238.166,
    y1: 167.486,
    x2: 237.804,
    y2: 168.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_1133_95138",
    x1: 245.111,
    y1: 171.597,
    x2: 244.749,
    y2: 172.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_1133_95138",
    x1: 226.486,
    y1: 127.786,
    x2: 226.746,
    y2: 154.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_1133_95138",
    x1: 214.069,
    y1: 127.39,
    x2: 213.392,
    y2: 138.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_1133_95138",
    x1: 212.014,
    y1: 135.848,
    x2: 211.937,
    y2: 137.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_1133_95138",
    x1: 214.225,
    y1: 137.133,
    x2: 214.149,
    y2: 138.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_1133_95138",
    x1: 216.436,
    y1: 138.414,
    x2: 216.359,
    y2: 140.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_1133_95138",
    x1: 212.014,
    y1: 132.918,
    x2: 211.937,
    y2: 134.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_1133_95138",
    x1: 214.225,
    y1: 134.196,
    x2: 214.149,
    y2: 135.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_1133_95138",
    x1: 216.436,
    y1: 135.481,
    x2: 216.359,
    y2: 137.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_1133_95138",
    x1: 212.014,
    y1: 129.984,
    x2: 211.937,
    y2: 131.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_1133_95138",
    x1: 214.225,
    y1: 131.269,
    x2: 214.149,
    y2: 132.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_1133_95138",
    x1: 216.436,
    y1: 132.55,
    x2: 216.359,
    y2: 134.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_1133_95138",
    x1: 238.166,
    y1: 145.057,
    x2: 237.805,
    y2: 145.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_1133_95138",
    x1: 245.109,
    y1: 149.168,
    x2: 244.748,
    y2: 149.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_1133_95138",
    x1: 226.486,
    y1: 105.351,
    x2: 226.746,
    y2: 131.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_1133_95138",
    x1: 214.069,
    y1: 104.953,
    x2: 213.392,
    y2: 116.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_1133_95138",
    x1: 212.014,
    y1: 113.408,
    x2: 211.937,
    y2: 115.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_1133_95138",
    x1: 214.226,
    y1: 114.693,
    x2: 214.149,
    y2: 116.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_1133_95138",
    x1: 216.436,
    y1: 115.982,
    x2: 216.359,
    y2: 117.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_1133_95138",
    x1: 212.014,
    y1: 110.478,
    x2: 211.937,
    y2: 112.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_1133_95138",
    x1: 214.226,
    y1: 111.763,
    x2: 214.149,
    y2: 113.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_1133_95138",
    x1: 216.436,
    y1: 113.049,
    x2: 216.359,
    y2: 114.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_1133_95138",
    x1: 212.014,
    y1: 107.549,
    x2: 211.937,
    y2: 109.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_1133_95138",
    x1: 214.225,
    y1: 108.834,
    x2: 214.149,
    y2: 110.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_1133_95138",
    x1: 216.436,
    y1: 110.115,
    x2: 216.359,
    y2: 111.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_1133_95138",
    x1: 238.166,
    y1: 122.621,
    x2: 237.805,
    y2: 123.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_1133_95138",
    x1: 245.109,
    y1: 126.732,
    x2: 244.748,
    y2: 127.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_1133_95138",
    x1: 226.486,
    y1: 82.9267,
    x2: 226.746,
    y2: 109.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_1133_95138",
    x1: 214.069,
    y1: 82.5302,
    x2: 213.392,
    y2: 93.6825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_1133_95138",
    x1: 212.014,
    y1: 90.9831,
    x2: 211.937,
    y2: 92.6446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_1133_95138",
    x1: 214.226,
    y1: 92.2682,
    x2: 214.149,
    y2: 93.9297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_1133_95138",
    x1: 216.436,
    y1: 93.5572,
    x2: 216.359,
    y2: 95.2187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_1133_95138",
    x1: 212.014,
    y1: 88.0537,
    x2: 211.937,
    y2: 89.7153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_1133_95138",
    x1: 214.226,
    y1: 89.3388,
    x2: 214.149,
    y2: 91.0003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_1133_95138",
    x1: 216.436,
    y1: 90.6239,
    x2: 216.359,
    y2: 92.2854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_1133_95138",
    x1: 212.014,
    y1: 85.1244,
    x2: 211.937,
    y2: 86.7859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_1133_95138",
    x1: 214.226,
    y1: 86.4095,
    x2: 214.149,
    y2: 88.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_1133_95138",
    x1: 216.436,
    y1: 87.6908,
    x2: 216.359,
    y2: 89.3522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_1133_95138",
    x1: 238.166,
    y1: 100.197,
    x2: 237.805,
    y2: 100.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_1133_95138",
    x1: 245.11,
    y1: 104.309,
    x2: 244.748,
    y2: 104.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_1133_95138",
    x1: 143.935,
    y1: 132.693,
    x2: 197.941,
    y2: 132.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525EAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_1133_95138",
    x1: 145.924,
    y1: 133.275,
    x2: 199.93,
    y2: 133.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_1133_95138",
    x1: 204.239,
    y1: 64.8226,
    x2: 152.047,
    y2: 99.3122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525EAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_1133_95138",
    x1: 194.811,
    y1: 159.641,
    x2: 155.533,
    y2: 188.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525EAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_1133_95138",
    x1: 214.828,
    y1: 102.105,
    x2: 140.568,
    y2: 156.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525EAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_1133_95138",
    x1: 184.296,
    y1: 268.745,
    x2: 194.683,
    y2: 287.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_1133_95138",
    x1: 111.442,
    y1: 298.218,
    x2: 111.442,
    y2: 255.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525EAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_1133_95138",
    x1: 131.992,
    y1: 294.947,
    x2: 150.754,
    y2: 225.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_1133_95138",
    x1: 132.976,
    y1: 291.327,
    x2: 145.892,
    y2: 243.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_1133_95138",
    x1: 143.156,
    y1: 254.957,
    x2: 158.963,
    y2: 254.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_1133_95138",
    x1: 128.028,
    y1: 248.984,
    x2: 142.526,
    y2: 248.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_1133_95138",
    x1: 179.084,
    y1: 156.23,
    x2: 169.623,
    y2: 123.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_1133_95138",
    x1: 177.371,
    y1: 159.186,
    x2: 173.678,
    y2: 140.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525EAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_1133_95138",
    x1: 173.933,
    y1: 127.782,
    x2: 174.012,
    y2: 145.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_1133_95138",
    x1: 184.187,
    y1: 134.386,
    x2: 175.371,
    y2: 141.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_1133_95138",
    x1: 162.883,
    y1: 138.781,
    x2: 178.266,
    y2: 138.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_1133_95138",
    x1: 173.684,
    y1: 132.768,
    x2: 173.519,
    y2: 133.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_1133_95138",
    x1: 173.684,
    y1: 133.823,
    x2: 173.519,
    y2: 134.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_1133_95138",
    x1: 173.684,
    y1: 134.876,
    x2: 173.519,
    y2: 135.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_1133_95138",
    x1: 173.132,
    y1: 135.608,
    x2: 172.967,
    y2: 135.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_1133_95138",
    x1: 167.003,
    y1: 135.773,
    x2: 166.838,
    y2: 136.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_1133_95138",
    x1: 167.003,
    y1: 136.836,
    x2: 166.838,
    y2: 137.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_1133_95138",
    x1: 167.003,
    y1: 137.889,
    x2: 166.838,
    y2: 138.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_1133_95138",
    x1: 166.531,
    y1: 138.666,
    x2: 166.366,
    y2: 138.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_1133_95138",
    x1: 174.299,
    y1: 140.056,
    x2: 174.134,
    y2: 140.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_1133_95138",
    x1: 174.299,
    y1: 141.109,
    x2: 174.134,
    y2: 141.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_1133_95138",
    x1: 174.299,
    y1: 142.164,
    x2: 174.134,
    y2: 142.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_1133_95138",
    x1: 173.827,
    y1: 142.944,
    x2: 173.662,
    y2: 143.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_1133_95138",
    x1: 167.254,
    y1: 141.976,
    x2: 167.089,
    y2: 142.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_1133_95138",
    x1: 167.254,
    y1: 143.023,
    x2: 167.089,
    y2: 143.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_1133_95138",
    x1: 166.783,
    y1: 143.806,
    x2: 166.618,
    y2: 144.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_1133_95138",
    x1: 167.182,
    y1: 129.045,
    x2: 165.799,
    y2: 131.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_1133_95138",
    x1: 174.647,
    y1: 146.343,
    x2: 173.655,
    y2: 148.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E82FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#5A70FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_1133_95138",
    x1: 167.254,
    y1: 146.19,
    x2: 167.089,
    y2: 146.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_1133_95138",
    x1: 167.254,
    y1: 147.248,
    x2: 167.089,
    y2: 147.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_1133_95138",
    x1: 166.783,
    y1: 148.028,
    x2: 166.618,
    y2: 148.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_1133_95138",
    x1: 174.647,
    y1: 150.557,
    x2: 173.655,
    y2: 152.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_1133_95138",
    x1: 167.254,
    y1: 150.408,
    x2: 167.089,
    y2: 150.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_1133_95138",
    x1: 167.254,
    y1: 151.462,
    x2: 167.089,
    y2: 151.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_1133_95138",
    x1: 166.783,
    y1: 152.242,
    x2: 166.618,
    y2: 152.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_1133_95138",
    x1: 174.648,
    y1: 154.779,
    x2: 173.656,
    y2: 156.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_1133_95138",
    x1: 148.778,
    y1: 138.87,
    x2: 139.26,
    y2: 136.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5CDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B96DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_1133_95138",
    x1: 125.619,
    y1: 219.936,
    x2: 142.322,
    y2: 219.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_1133_95138",
    x1: 140.092,
    y1: 154.107,
    x2: 158.556,
    y2: 154.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E82FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#5A70FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_1133_95138",
    x1: 121.974,
    y1: 168.935,
    x2: 154.5,
    y2: 168.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E82FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#5A70FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_1133_95138",
    x1: 147.747,
    y1: 165.458,
    x2: 174.075,
    y2: 165.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E82FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#5A70FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_1133_95138",
    x1: 134.56,
    y1: 223.817,
    x2: 156.554,
    y2: 223.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_1133_95138",
    x1: 130.055,
    y1: 130.01,
    x2: 151.005,
    y2: 130.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_1133_95138",
    x1: 164.38,
    y1: 146.449,
    x2: 158.925,
    y2: 145.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5CDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B96DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_1133_95138",
    x1: 178.048,
    y1: 156.724,
    x2: 172.764,
    y2: 155.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5CDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B96DE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg503);
export default __webpack_public_path__ + "static/media/503.de78472492948afd2e9f3646490fc195.svg";
export { ForwardRef as ReactComponent };